import { render, staticRenderFns } from "./saleAfterService.vue?vue&type=template&id=37ab563a&scoped=true"
import script from "./saleAfterService.vue?vue&type=script&lang=js"
export * from "./saleAfterService.vue?vue&type=script&lang=js"
import style0 from "./saleAfterService.vue?vue&type=style&index=0&id=37ab563a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ab563a",
  null
  
)

export default component.exports